/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

const Map = ({ themeMode = 'light' }: { themeMode: "light" | "dark" }) => {
    const { t } = useTranslation();

    return (
        <Box>
            <Box>
                <Typography
                    sx={{
                        textTransform: 'uppercase',
                        fontWeight: 'medium',
                    }}
                    gutterBottom
                    color={'textSecondary'}
                >
                    {t("contacts_page.contact_data")}
                </Typography>
                <Box marginBottom={2}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 600,
                        }}
                    >
                        {t("contacts_page.call_us")}
                    </Typography>
                </Box>
            </Box>
            <Box marginY={4}>
                <Box
                    component={'iframe'}
                    borderRadius={2}
                    minHeight={400}
                    width="100%"
                    height="100%"
                    title="map"
                    scrolling="no"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d160182.53790686463!2d71.33930651654029!3d51.148077422650026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x424580c47db54609%3A0x97f9148dddb19228!2sNur-Sultan%20020000!5e0!3m2!1sen!2skz!4v1648024769592!5m2!1sen!2skz"
                    sx={{
                        filter:
                            themeMode === 'dark' ? 'grayscale(0.5) opacity(0.7)' : 'none',
                    }}
                />
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: 'medium' }}
                    >
                        {t("contacts_page.phone")}
                    </Typography>
                    <Typography variant={'subtitle1'}>+7 747 596 30 16</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: 'medium' }}
                    >
                        {t("contacts_page.email")}
                    </Typography>
                    <Typography variant={'subtitle1'}>support@etpzakup.kz</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        variant={'body1'}
                        gutterBottom
                        sx={{ fontWeight: 'medium' }}
                    >
                        {t("contacts_page.address")}
                    </Typography>
                    <Typography variant={'subtitle1'}>
                        {t("contacts_page.city")}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

Map.propTypes = {
    themeMode: PropTypes.string.isRequired,
};

export default Map;
